/** 用户信息相关 */
export default{
    namespaced: true,// 开启命名空间
    state:()=>({
        nickName:'未登录'
    }),
    mutations:{
        SET_NICK_NAME: (state, nickName) => {
            state.nickName = nickName
        },
        /** 登出清空vuex状态 */
        LOGIN_OUT(state){
            state.nickName='未登录'
        },        
    },
    actions:{},
    getters:{}
}